import React, { Component } from 'react';
import Mac from './../images/mac.jpg';
import { TimelineMax, Power1, CSSPlugin } from "gsap/all";



const plugins = [CSSPlugin];
// Create an object with the custom captions that you want to use
const works = [
    {
        src: require('./../data/works/100aWeek.png'),
        thumbnail: require('./../data/works/thumbs/100aWeek.png'),
        imageText: 'Dummy Text',
        width: 1920,
        height: 'auto',
        caption: (<div className="lighbox-caption">She found herself in a <a href="https://www.youtube.com/" target="_blank">forest...</a></div>),
    },
    {
        src: require('./../data/works/1SmallStep.png'),
        thumbnail: require('./../data/works/thumbs/1SmallStep.png'),
        imageText: 'Dummy Text',
        width: 1920,
        height: 'auto',
        caption: (<div className="lighbox-caption">She found herself in a <a href="https://www.youtube.com/" target="_blank">forest...</a></div>),
    },
    {
        src: require('./../data/works/1SmallStepForCancer.png'),
        thumbnail: require('./../data/works/thumbs/1SmallStepForCancer.png'),
        imageText: 'Dummy Text',
        width: 1920,
        height: 'auto',
        caption: (<div className="lighbox-caption">She found herself in a <a href="https://www.youtube.com/" target="_blank">forest...</a></div>),
    },
    {
        src: require('./../data/works/Challenger_Sweepers.jpg'),
        thumbnail: require('./../data/works/thumbs/Challenger_Sweepers.jpg'),
        imageText: 'Dummy Text',
        width: 1920,
        height: 'auto',
        caption: (<div className="lighbox-caption">She found herself in a <a href="https://www.youtube.com/" target="_blank">forest...</a></div>),
    },
    {
        src: require('./../data/works/Dabang_Delhi.jpg'),
        thumbnail: require('./../data/works/thumbs/Dabang_Delhi.jpg'),
        imageText: 'Dummy Text',
        width: 1920,
        height: 'auto',
        caption: (<div className="lighbox-caption">She found herself in a <a href="https://www.youtube.com/" target="_blank">forest...</a></div>),
    },
    {
        src: require('./../data/works/Dabang_Smashers.jpg'),
        thumbnail: require('./../data/works/thumbs/Dabang_Smashers.jpg'),
        imageText: 'Dummy Text',
        width: 1920,
        height: 'auto',
        caption: (<div className="lighbox-caption">She found herself in a <a href="https://www.youtube.com/" target="_blank">forest...</a></div>),
    },
    {
        src: require('./../data/works/High_Street_Pheonix.png'),
        thumbnail: require('./../data/works/thumbs/High_Street_Pheonix.png'),
        imageText: 'Dummy Text',
        width: 1920,
        height: 'auto',
        caption: (<div className="lighbox-caption">She found herself in a <a href="https://www.youtube.com/" target="_blank">forest...</a></div>),
    },
    // {
    //   src: require('./../data/works/High_Street_Phoenix_-_Home.png'),
    //   thumbnail: require('./../data/works/thumbs/High_Street_Phoenix_-_Home.png'),
    //   imageText: 'Dummy Text',
    //   width: 1920,
    //   height: 'auto',
    //   caption: (<div className="lighbox-caption">She found herself in a <a href="https://www.youtube.com/" target="_blank">forest...</a></div>),
    // },
    {
        src: require('./../data/works/hsp_desktop.jpg'),
        thumbnail: require('./../data/works/thumbs/hsp_desktop.png'),
        imageText: 'Dummy Text',
        width: 1920,
        height: 'auto',
        caption: (<div className="lighbox-caption">She found herself in a <a href="https://www.youtube.com/" target="_blank">forest...</a></div>),
    },
    // {
    //   src: require('./../data/works/hsp_mob.jpg'),
    //   thumbnail: require('./../data/works/thumbs/hsp_mob.jpg'),
    //   imageText: 'Dummy Text',
    //   width: 1920,
    //   height: 'auto',
    //   caption: (<div className="lighbox-caption">She found herself in a <a href="https://www.youtube.com/" target="_blank">forest...</a></div>),
    // },
    {
        src: require('./../data/works/maharashtra_united.jpg'),
        thumbnail: require('./../data/works/thumbs/maharashtra_united.png'),
        imageText: 'Dummy Text',
        width: 1920,
        height: 'auto',
        caption: (<div className="lighbox-caption">She found herself in a <a href="https://www.youtube.com/" target="_blank">forest...</a></div>),
    },
    {
        src: require('./../data/works/palladium.png'),
        thumbnail: require('./../data/works/thumbs/palladium.png'),
        imageText: 'Dummy Text',
        width: 1920,
        height: 'auto',
        caption: (<div className="lighbox-caption">She found herself in a <a href="https://www.youtube.com/" target="_blank">forest...</a></div>),
    },
    {
        src: require('./../data/works/Protinex_Grow.jpg'),
        thumbnail: require('./../data/works/thumbs/Protinex_Grow.jpg'),
        imageText: 'Dummy Text',
        width: 1920,
        height: 'auto',
        caption: (<div className="lighbox-caption">She found herself in a <a href="https://www.youtube.com/" target="_blank">forest...</a></div>),
    },
    {
        src: require('./../data/works/Subhadra.png'),
        thumbnail: require('./../data/works/thumbs/Subhadra.png'),
        imageText: 'Dummy Text',
        width: 1920,
        height: 'auto',
        caption: (<div className="lighbox-caption">She found herself in a <a href="https://www.youtube.com/" target="_blank">forest...</a></div>),
    },
    {
        src: require('./../data/works/Viacom18.jpg'),
        thumbnail: require('./../data/works/thumbs/Viacom18.jpg'),
        imageText: 'Dummy Text',
        width: 1920,
        height: 'auto',
        caption: (<div className="lighbox-caption">She found herself in a <a href="https://www.youtube.com/" target="_blank">forest...</a></div>),
    },
    {
        src: require('./../data/works/Welspun_Hospitality_Textiles.jpg'),
        thumbnail: require('./../data/works/thumbs/Welspun_Hospitality_Textiles.jpg'),
        imageText: 'Dummy Text',
        width: 1920,
        height: 'auto',
        caption: (<div className="lighbox-caption">She found herself in a <a href="https://www.youtube.com/" target="_blank">forest...</a></div>),
    },
];

class Works extends Component {
    constructor(props) {
        super(props);
        this.timeline = new TimelineMax({ paused: true });
        this.headerDivs = [];
        this.contentDivs = [];
    }
    componentDidMount() {
        window.scrollTo(0, 0);
        this.timeline
            .staggerFrom(this.headerDivs, 0.4, {
                autoAlpha: 0,
                // stagger: 0.1,
                //x: 25,
                delay: 0.25,
                ease: Power1.easeInOut
            }, 0.2)
            .staggerFrom(this.contentDivs, 0.4, {
                autoAlpha: 0,
                // stagger: 0.1,
                x: 25,
                ease: Power1.easeInOut
            }, 0.2);

        this.timeline.play();
    }
    render() {
        const props = this.props;
        return (
            <div className="view-page-container works-page">
                <div className="container">
                    <h2 className="text-center main-header" ref={div => (this.headerDivs[1] = div)}>My Works</h2>
                    <div className="lead text-center" ref={div => (this.headerDivs[2] = div)}>Some of my development works</div>
                    <hr />
                    <div className="row">
                        {
                            works.map((work, key) =>
                                <div key={key} className="col-md-4 mb-4" ref={div => (this.contentDivs[key] = div)}>
                                    <a className="shadow d-block border-light border rounded overflow-hidden" data-fancybox="my-works" href={work.src}>
                                        <img className="img-fluid" src={work.thumbnail} />
                                    </a>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div >
        );
    }
}
export default Works;
